import "rxjs/Rx";

import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class PersonService {
  constructor(private http: HttpClient) {}

  getPerson(personId: string): Observable<Object> {
    return this.http.get("/api/PEople/" + personId).map(res => {
      const data = (<any>res).json();
      return data;
    });
  }

  uploadFile(file: File, description: string, documentTypeId: string) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    formData.append("description", description);
    formData.append("documentTypeId", documentTypeId);

    const req = new HttpRequest("POST", "/api/AwsS3/uploadDocument", formData, {
      responseType: "json"
    });
    return this.http.request(req);
  }

  downloadFile(fileName: string) {
    return window.open("/api/AwsS3/downloadDocument?file=" + fileName);
  }

  deleteFile(fileName: string) {
    const req = new HttpRequest(
      "GET",
      "/api/AwsS3/deleteDocument?file=" + fileName
    );
    return this.http.request(req);
  }

  getPersonById(text: string) {
    return this.http.get(`/api/person/Person`, {
      params: { type: text },
      responseType: "json"
    });
  }

  getPersonNameById(personId: string) {
    return this.http.get(`/api/PersonName/getPersonNameById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  getPersonAddressById(personId: string) {
    return this.http.get(`/api/PersonAddress/getPersonAddressById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  getPersonDocumentById(personId: string) {
    return this.http.get(`/api/PersonDocument/getPersonDocumentById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  getPersonDisabilityById(personId: string) {
    return this.http.get(`/api/PersonDisability/getPersonDisabilityById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  getInternalPersonDisabilityById(personId: string) {
    return this.http.get(
      `/api/InternalPersonDisability/getPersonDisabilityById`,
      { params: { type: personId }, responseType: "json" }
    );
  }

  getPersonPlanById(personId: string) {
    return this.http.get(`/api/PersonPlan/getPersonPlanById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  getPersonTestById(personId: string) {
    return this.http.get(`/api/PersonTest/getPersonTestById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  getRequestForDisplay(requestId: string) {
    return this.http.get(`/api/Request/getRequestForDisplay`, {
      params: { requestId: requestId },
      responseType: "json"
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/person.service.ts